module.exports = __webpack_public_path__ + "static/media/31_tn.17dca022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/31_tn.jpg
// module id = 169
// module chunks = 0